import { render, staticRenderFns } from "./CustomerSalesTable.vue?vue&type=template&id=114e22b2&"
import script from "./CustomerSalesTable.vue?vue&type=script&lang=js&"
export * from "./CustomerSalesTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSalesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports